/** Defaults alineados con functions/common/dispatch.js (1.ª ola = driverRadius). */
export const DEFAULT_DRIVER_RADIUS = 10;
export const DEFAULT_WAVE2_AFTER_MIN = 1;
export const DEFAULT_WAVE2_FACTOR = 1.5;
export const DEFAULT_WAVE3_AFTER_MIN = 3;
export const DEFAULT_WAVE3_FACTOR = 2;

export const WAVE_AFTER_MIN_RANGE = { min: 0, max: 30 };
export const DRIVER_RADIUS_RANGE = { min: 0.5, max: 100 };

/**
 * Radio de la 1.ª ola en unidades del panel (km o millas según convert_to_mile).
 */
export function resolveDriverRadius(settings = {}) {
  const n = Number(settings.driverRadius);
  return n > 0 ? n : DEFAULT_DRIVER_RADIUS;
}

/**
 * Etapas de despacho: [{ fromMin, radius }] en unidades del panel, ordenadas por fromMin.
 * Olas 2/3: radio absoluto si está en settings; si no, factor × radio ola 1.
 */
export function resolveDispatchWaveStages(settings = {}) {
  const base = resolveDriverRadius(settings);
  const w2AfterRaw = Number(settings.dispatchWave2AfterMin);
  const w3AfterRaw = Number(settings.dispatchWave3AfterMin);
  const w2After = Number.isFinite(w2AfterRaw) && w2AfterRaw >= 0
    ? w2AfterRaw
    : DEFAULT_WAVE2_AFTER_MIN;
  const w3After = Number.isFinite(w3AfterRaw) && w3AfterRaw >= 0
    ? w3AfterRaw
    : DEFAULT_WAVE3_AFTER_MIN;

  const w2Radius = Number(settings.dispatchWave2Radius) > 0
    ? Number(settings.dispatchWave2Radius)
    : base * DEFAULT_WAVE2_FACTOR;
  const w3Radius = Number(settings.dispatchWave3Radius) > 0
    ? Number(settings.dispatchWave3Radius)
    : base * DEFAULT_WAVE3_FACTOR;

  return [
    { fromMin: 0, radius: base, wave: 1 },
    { fromMin: w2After, radius: w2Radius, wave: 2 },
    { fromMin: w3After, radius: w3Radius, wave: 3 },
  ].sort((a, b) => a.fromMin - b.fromMin || a.wave - b.wave);
}

/** Radio efectivo de despacho según minutos desde tripdate. */
export function resolveDispatchRadius(settings = {}, minsLate = 0) {
  const stages = resolveDispatchWaveStages(settings);
  let radius = stages[0].radius;
  const t = Number(minsLate) || 0;
  stages.forEach((stage) => {
    if (t >= stage.fromMin) radius = stage.radius;
  });
  return radius;
}
